import api_base from "@/api/base";

export type GuideModule =
  | "general_overview"
  | "home_dashboard"
  | "clients"
  | "cases"
  | "appointments"
  | "team_permissions"
  | "invoicing"
  | "expenses"
  | "adversaries"
  | "fees"
  | "lawyer_assignment"
  | "external_lawyers"
  | "ai_assistant"
  | "settings"
  | "dossier_mobile"
  | "other";

export interface Guide {
  id: string;
  title: string;
  link: string;
  functionality: GuideModule;
  body: string;
  tags: string[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ProposeGuideResponse {
  message: string;
  guide: Guide | null;
}

export const proposeGuide = async (
  module: GuideModule
): Promise<ProposeGuideResponse> => {
  const response = await api_base.get("/api/v1/guides/propose/", {
    params: { module },
  });
  return response.data;
};

export interface ListGuidesParams {
  functionality?: GuideModule;
  search?: string;
  ordering?: string;
  page_size?: number;
}

export const listGuides = async (
  params?: ListGuidesParams
): Promise<Guide[]> => {
  const response = await api_base.get("/api/v1/guides/", {
    params: { page_size: 100, ...params },
  });
  // Backend paginates ({ count, results }); tolerate a bare array too.
  return Array.isArray(response.data) ? response.data : response.data.results;
};

export const getGuide = async (id: string): Promise<Guide> => {
  const response = await api_base.get(`/api/v1/guides/${id}/`);
  return response.data;
};
